import { CommandRequestType } from 'app/services/authentication/connection/commandRequestType';
import { ICommandParameters } from 'app/services/authentication/connection/iCommandParameters';
import { ICommandResponse } from 'app/services/authentication/connection/iCommandResponse';
import { ErrorDetails } from 'app/services/authentication/connection/interfaces/apiInterfaces';
import { IRequestCommand } from 'app/services/authentication/connection/iRequestCommand';
import { IRecurringTripResponseDTO } from './getRecurringTrip.command';

export class GetCanceledRecurringTripCommand extends IRequestCommand<
  IGetCanceledRecurringTripResponse,
  ErrorDetails,
  IGetCanceledRecurringTripCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/{carrierId}/recurringTripCanceled/paginated';

  public override setParameters(parameters: IGetCanceledRecurringTripCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.carrierId.toString()
    );
    const params: string[] = [];
    params.push(`page=${parameters.page}`);
    params.push(`size=${parameters.size}`);
    params.push(`column=${parameters.column}`);
    params.push(`sort=${parameters.sort}`);
    if (parameters.find !== undefined && parameters.find !== null) {
      params.push(`find=${encodeURIComponent(parameters.find)}`);
    }
    this._commandUrl += '?' + params.join('&');
  }
}

export interface IGetCanceledRecurringTripCommandParameters extends ICommandParameters {
  carrierId: number;
  page: number;
  size: number;
  column: string;
  sort: string;
  find?: string;
}

export interface IGetCanceledRecurringTripResponse extends ICommandResponse {
  content: IRecurringTripResponseDTO[];
  totalElements: number;
  totalPages: number;
}
